import { ReactNode } from 'react';

import { Card, CardContent } from '@/components/ui/card';

type SummaryCardRow = {
    label: string;
    value: ReactNode;
};

type SummaryCardProps = {
    title: string;
    statLabel: string;
    statValue: string;
    rows: SummaryCardRow[];
    caption: ReactNode;
};

export const SummaryCard = ({ title, statLabel, statValue, rows, caption }: SummaryCardProps) => (
    <section className="space-y-2">
        <h2 className="text-sm font-semibold tracking-wide text-gray-900">{title}</h2>
        <Card className="rounded-xl">
            <CardContent className="space-y-4 p-5">
                <div>
                    <p className="text-muted-foreground text-xs font-semibold tracking-wide uppercase">{statLabel}</p>
                    <div className="mt-1 flex items-end gap-2">
                        <span className="text-4xl leading-none font-semibold">{statValue}</span>
                        <span className="text-muted-foreground text-sm">groups</span>
                    </div>
                </div>
                <div className="space-y-2 border-b pb-4">
                    {rows.map((row) => (
                        <div key={row.label} className="flex items-center justify-between gap-4">
                            <span className="text-muted-foreground text-sm">{row.label}</span>
                            {row.value}
                        </div>
                    ))}
                </div>
                {caption}
            </CardContent>
        </Card>
    </section>
);
